import React from "react";
import { Box, Typography } from "@mui/material";
import {
  adminFeatureIconSx,
  adminSectionDescSx,
  adminSectionTitleSx,
} from "../shared/styles";

function AdminFeatureSection({ icon, iconSx, title, description, action, children }) {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: "16px",
        }}
      >
        <Box sx={{ ...adminFeatureIconSx, ...iconSx }}>{icon}</Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: "16px",
            }}
          >
            <Box>
              <Typography component="p" sx={adminSectionTitleSx}>
                {title}
              </Typography>
              <Typography component="p" sx={{ ...adminSectionDescSx, mt: "4px" }}>
                {description}
              </Typography>
            </Box>
            {action || null}
          </Box>
        </Box>
      </Box>
      {children ? <Box sx={{ mt: "24px" }}>{children}</Box> : null}
    </Box>
  );
}

export default AdminFeatureSection;
